
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Services = lazy(() => import('../pages/services/page'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: React.createElement(Home),
  },
  {
    path: '/services',
    element: React.createElement(Services),
  },
  {
    path: '/pricing',
    element: React.createElement(Pricing),
  },
  {
    path: '/about',
    element: React.createElement(About),
  },
  {
    path: '/contact',
    element: React.createElement(Contact),
  },
  {
    path: '*',
    element: React.createElement(NotFound),
  },
];

export default routes;
